<template>
   <v-container v-if="this.condition()" fluid>
      <v-row dense>
            <v-col cols="12">
    <v-card elevation="2">
      <v-card-title>Indicateurs financiers</v-card-title>
        <!-- <PictoItem v-bind:data="defaillancePicto" v-if = "this.defaillancePicto!=null"/> -->
          <PictoItem v-bind:data="impayesPicto" v-if = "this.impayesPicto!=null"/>
      <br/>
          <!-- <PictoItem v-bind:data="scorecreditPicto" v-if = "this.scorecreditPicto!=null && defaillancePicto==null"/> -->
          <!-- <PictoItem v-bind:data="scoreCovidPicto" v-if = "this.scoreCovidPicto!=null"/> -->
          <!-- <PictoItem v-bind:data="defaillanceGratuite"  v-if = "this.defaillanceGratuite!=null"/> -->
    </v-card>
            </v-col>
      </v-row>
</v-container>

</template>


<script>

import PictoItem from "@/components/layout/PictoItem.vue";

export default {
  name: 'FinanceResume',
  props: [''],
components: {
    PictoItem,
  },
   created() {

     this.impayeColor = {
       "PREAVIS": "yellow",
       "MED": "orange",
       "SUSP+": "red",
       "Aucun": "green",
       "indéfini": "grey",
       "Suspension_Garanties ou plus":"red",
      "Preavis" : "yellow"
     }
   },
  computed: {

    scorecredit: function () {
      var score = this.$store.getters.getbloc("finance", "indicateurs", "score_credit_detail")
      if (score == null) {
        score = this.$store.getters.getbloc("finance", "indicateurs", "score_credit")
      }

      return score
    },

    defaillancePicto : function() {
      var defaillance = this.$store.getters.getbloc("finance", "indicateurs", "score_defaillance")

       if (defaillance && defaillance.valeur != null && defaillance.valeur.warning) {
         return {
           "id": "blocfinance",
           "tooltip": "Risque de défaillance : "+ defaillance.libelle,
           "icon": "mdi-credit-card-remove-outline",
           "color": "grey",
          // FIXME "color": defaillance.valeur.warning ? "red" : "green",
           "text": defaillance.libelle
         }
       } else {
          return null

       }
    },
     impayesPicto : function() {
      var impayes = this.$store.getters.getbloc("finance", "donnees", "impayes")
       if (impayes && impayes.valeur != null) {
         return {
           "id": "blocfinance",
           "tooltip": "Historique Impayés : "+ (impayes.valeur.plus_grand_retard == "MED" ? "Mise en demeure" : impayes.valeur.plus_grand_retard),
           "icon": "mdi-currency-eur-off",
           "color": this.impayeColor[impayes.valeur.plus_grand_retard],
           "text": (impayes.valeur.plus_grand_retard == "MED" ? "Mise en demeure" : impayes.valeur.plus_grand_retard)
         }
       } else {
          return {
           "id": "blocfinance",
           "tooltip": "Historique Impayés : inconnu",
           "icon": "mdi-currency-eur-off",
           "color":"grey",
            "text": "indéfini"
          }
       }
    },


    scorecreditPicto : function() {
       if (this.scorecredit && this.scorecredit.valeur != null) {
         return {
           "id": "blocfinance",
           "tooltip": "Score de crédit : " + this.scorecredit.libelle,
           "icon": "credit_card",
           "color": this.scorecredit.valeur.couleur,
           "text": this.scorecredit.valeur.note
         }
       } else {
         return null
       }
    }
     ,
     scoreCovidPicto : function() {
      if (this.scorecredit && this.scorecredit.valeur != null  &&  this.scorecredit.valeur.covid_impact!=null) {
        return {
          "id": "blocfinance",
          "tooltip": this.scorecredit.valeur.covid_impact,
          "icon": "coronavirus",
          "color": this.scorecredit.valeur.covid_impact == "Vigilance forte" ? "red" : "grey",
          "text": "COVID : "+this.scorecredit.valeur.covid_impact,
        }
      } else {
        return null
      }
     },
      defaillanceGratuitePicto : function() {
      if (this.defaillance) {
        return {
          "id": "blocfinance",
          "tooltip": this.defaillanceGratuite,
          "icon": "broken_image",
          "color": "red",
          "text":  this.defaillanceGratuite,
        }
      } else {
        return null
      }
     },

    defaillanceGratuite: function () {
      return this.$store.getters.getbloc("finance", "indicateurs", "defaillanceGratuit",null, "libelle")
    },



  },
  methods: {
    condition() {
      return this.$store.getters.condition("finance", "donnees") || this.$store.getters.condition("finance", "indicateurs")
    },

  }
};
</script>
